document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll(".where-to-buy").forEach(section => {

        const tabs = section.querySelectorAll(".where-tab");

        tabs.forEach(tab => {

            tab.addEventListener("click", function(){

                tabs.forEach(t=>t.classList.remove("active"));

                this.classList.add("active");

                section.querySelectorAll(".where-content").forEach(content=>{

                    content.classList.remove("active");

                });

                section.querySelector("#"+this.dataset.tab).classList.add("active");

            });

        });

    });

});